import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { type LanTypes, getLanguageCode } from "@src/helpers";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type TCountry } from "@src/api/useBirthCountries";

export const GET_CITIZENSHIP_COUNRTIES_KEY = "getGetCitizenshipCountries";

const getGetCitizenshipCountries = async (
  language: LanTypes,
  IsBirthCountries?: boolean,
) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<{ countries: TCountry[] }>(
    `/api/customer/citizenshipcountries`,
    {
      params: {
        lang: languageCode,
        IsBirthCountries,
      },
      headers: { langcode: languageCode },
    },
  );
  return response.data;
};

export const useCitizenshipCountries = (IsBirthCountries?: boolean) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [GET_CITIZENSHIP_COUNRTIES_KEY, IsBirthCountries, i18n.language],
    queryFn: () =>
      getGetCitizenshipCountries(i18n.language as LanTypes, IsBirthCountries),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
